<template>

    <div class="chart-dog-step-1">

        <!-- main chart attrs -->

        <b-form-group label="Main Chart Title">
            <b-form-input type="text" required
                          v-model="docData.chart.chartTitle"/>
        </b-form-group>

        <b-form-group label="X Axis Label">
            <b-form-input type="text" required
                          v-model="docData.chart.xAxisLabel"/>
        </b-form-group>

        <b-form-group label="Y Axis Label">
            <b-form-input type="text" required
                          v-model="docData.chart.yAxisLabel"/>
        </b-form-group>

        <b-row>
            <b-col>
                <b-form-group label="Y Axis Minimum">
                    <b-form-input type="text" required
                                  v-model="docData.chart.yAxisMin"/>
                </b-form-group>
            </b-col>
            <b-col>
                <b-form-group label="Y Axis Maximum">
                    <b-form-input type="text" required
                                  v-model="docData.chart.yAxisMax"/>
                </b-form-group>
            </b-col>
        </b-row>

        <!-- series -->

        <b-btn variant="primary" size="lg" class="fixed-action-button"
               @click="addChartSeries()">
            <open-icon name="plus"></open-icon>
            Add A Series
        </b-btn>

        <b-card no-body class="mb-3"
                v-for="(series, index) in docData.chart.chartSeries">
            <b-card-header>
                Series {{ index + 1 }}
                <chart-dog-legend-label :series-shape="series.marker.name"
                                        :series-color-code="series.color.code"
                                        :phase-index="null">
                </chart-dog-legend-label>
                <b-btn variant="danger" size="sm" class="float-right"
                       @click="deleteChartSeries(series)">
                    <open-icon name="delete"></open-icon>
                </b-btn>
            </b-card-header>
            <b-card-body>
                <b-row>
                    <b-col>
                        <b-form-group label="Series Title">
                            <b-form-input type="text" required
                                          v-model="series.title"/>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" md="6">
                        <b-form-group label="Line Color">
                            <b-dropdown :text="series.color.label"
                                        class="m-md-2">
                                <b-dropdown-item v-for="color in tool.options.seriesColors"
                                                 :class="`color-selector color-selector-${color.label}`"
                                                 @click="setSeriesColor(series, color)">
                                    <span class="color-chip"></span>
                                    <span class="color-label">{{ color.label }}</span>
                                </b-dropdown-item>
                            </b-dropdown>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6">
                        <b-form-group label="Shape">
                            <b-dropdown :text="series.marker.label"
                                        class="m-md-2">
                                <b-dropdown-item v-for="marker in tool.options.seriesMarkers"
                                                 :class="`marker-selector marker-selector-${marker.label}`"
                                                 @click="setSeriesMarker(series, marker)">
                                    <span class="marker-icon">{{ marker.label }}</span>
                                </b-dropdown-item>
                            </b-dropdown>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6">
                        <b-form-group label="Size">
                            <b-form-select v-model="series.size">
                                <option value="S">Small</option>
                                <option value="M">Medium</option>
                                <option value="L">Large</option>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-card>

    </div>

</template>

<script>

    import Vue from 'vue'
    import ToolMixin from '@/providers/ToolMixin'
    import ChartDog from "@/components/ChartDog"
    import ChartDogMixin from "@/providers/ChartDogMixin"

    export default Vue.extend({
        name: "ChartDogStep1",
        mixins: [ToolMixin, ChartDogMixin],
        computed: {
            thisStepIsValid() {
                return true
            },
        },
    })

</script>


